import { Component, OnInit } from '@angular/core';
import {CommonService} from '../../../services/common.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {Router} from "@angular/router";

@Component({
  selector: 'app-forms-summary',
  templateUrl: './forms-summary.component.html',
  styleUrls: ['./forms-summary.component.scss']
})
export class FormsSummaryComponent implements OnInit {
  isLoading: boolean;
  forms = [];
  gaugeType: any;
  threshold1: any;
  threshold2: any;
  threshold3: any;
  constructor(public router: Router, private commonService: CommonService, public toastMessagesService: ToastMessagesService) {
    this.gaugeType = 'full';
    this.threshold1 = { 0: {color: 'green'} };
    this.threshold2 = { 0: {color: 'orange'} };
    this.threshold3 = { 0: {color: '#08044c'} };

    this.isLoading = true;
  }

  async ngOnInit() {
    await this.initForms();
  }


  async initForms() {
    try {
      const result = await this.commonService.getList(`statistics/forms`);
      this.forms = result.object;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  getGDPRFormsNumber() {
    const forms = this.forms.filter(f => f.form_type_id === 1 && f.isGDPR);
    return forms.length;
  }

  getRestFormsNumber() {
    const forms = this.forms.filter(f => f.form_type_id === 1 && !f.isGDPR);
    return forms.length;
  }

  getAnnouncementFormsNumber() {
    const forms = this.forms.filter(f => f.form_type_id === 3);
    return forms.length;
  }

  async navigateToForms() {
    await this.router.navigate(['home/forms']);
  }
}
